'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    img {\n        max-width: 100%;\n        margin-bottom: 15px;\n    }\n    h1,h2,h3,h4,h5,h6 {\n        margin-top: 0;\n\t\tmargin-bottom: .5em;\n\t\tcolor: rgba(0, 0, 0, 0.85);\n\t\tfont-weight: 500;\n\t}\n'], ['\n    img {\n        max-width: 100%;\n        margin-bottom: 15px;\n    }\n    h1,h2,h3,h4,h5,h6 {\n        margin-top: 0;\n\t\tmargin-bottom: .5em;\n\t\tcolor: rgba(0, 0, 0, 0.85);\n\t\tfont-weight: 500;\n\t}\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

var Tag = function Tag(_ref) {
    var tag = _ref.tag,
        text = _ref.text,
        item = _ref.item;
    return _react2.default.createElement(
        Container,
        null,
        _react2.default.createElement(_Text2.default, { text: '<' + tag + ' ' + (item.css || '') + '>' + (text || '') + '</' + tag + '>' })
    );
};

Tag.propTypes = {
    tag: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    item: _propTypes2.default.object.isRequired
};

exports.default = Tag;